document.addEventListener('DOMContentLoaded', function () {

  const paymentBlock = document.querySelector('[data-block-id="payment_block_6jDMed"]');
  const buyButtons = document.querySelector('.buy-buttons-row');

  if (paymentBlock && buyButtons) {
    buyButtons.insertAdjacentElement('afterend', paymentBlock);
  }

  const slider = document.querySelector('.shopify-section.rw-slider');

  const targetRow = [...document.querySelectorAll('.lightly-spaced-row.not-in-quickbuy')]
    .find(row => row.querySelector('.btn--secondary.btn--link'));

  if (slider && targetRow) {
    targetRow.insertAdjacentElement('afterend', slider);
  }

  const moneyBack = document.querySelector('.shopify-section.money-back');

  if (slider && moneyBack) {
    slider.insertAdjacentElement('afterend', moneyBack);
  }

  // --- Cluster variant gallery: variant-specific images via metafields ---
  var $gallery = $('.gallery[data-cluster-variant-gallery]');
  if ($gallery.length) {
    var $slideshow = $gallery.find('.product-slideshow');
    var $thumbnails = $gallery.find('.thumbnails');
    var $slidesStore = $gallery.find('.cluster-variant-slides-store');
    var $thumbsStore = $gallery.find('.cluster-variant-thumbs-store');
    var currentVariantId = String($gallery.data('cluster-current-variant'));

    function activateLazyImages($container) {
      $container.find('img[data-src]').each(function () {
        this.src = this.dataset.src;
        if (this.dataset.srcset) this.srcset = this.dataset.srcset;
        this.classList.add('loaded');
      });
    }

    function switchVariantGallery(variantId) {
      variantId = String(variantId);
      if (!variantId || variantId === currentVariantId) return;

      var $newSlides = $slidesStore.find('[data-cluster-variant-id="' + variantId + '"]');
      if (!$newSlides.length) return;
      currentVariantId = variantId;

      // Pause any playing videos
      $slideshow.find('video').each(function () { this.pause(); });

      // Destroy Slick
      var previousSlickSettings = null;
      if ($slideshow.hasClass('slick-initialized')) {
        previousSlickSettings = $.extend(true, {}, $slideshow.slick('getSlick').originalSettings);
        $slideshow.slick('unslick');
      }

      // Swap slides and re-init
      $slideshow.html($newSlides.html());
      activateLazyImages($slideshow);
      var reinitSlickSettings = previousSlickSettings || {
        adaptiveHeight: true,
        initialSlide: 0
      };
      reinitSlickSettings.initialSlide = 0;
      $slideshow.slick(reinitSlickSettings);

      // Swap thumbnails
      var $newThumbs = $thumbsStore.find('[data-cluster-variant-id="' + variantId + '"]');
      if ($newThumbs.length) {
        $thumbnails.html($newThumbs.html());
        activateLazyImages($thumbnails);
      }
    }

    // Intercept variantImageSelected to block the theme's default gallery handler
    $gallery.on('variantImageSelected', function (e, data) {
      e.stopImmediatePropagation();
      if (data && data.id) switchVariantGallery(data.id);
    });

    // Fallback: cc-variant-updated fires even when variant has no featured_media
    $(window).on('cc-variant-updated', function (e, args) {
      if (args && args.variant && args.variant.id) {
        if ($slidesStore.find('[data-cluster-variant-id="' + args.variant.id + '"]').length) {
          switchVariantGallery(args.variant.id);
        }
      }
    });
  }

});
